import { Diamond } from "lucide-react";

export default function HookSection({ t }) {
  if (!t.hookQuote) return null;
  return (
    <section className="relative bg-[#0A0807] text-white overflow-hidden py-20 sm:py-28 lg:py-32" data-testid="weddings-hook">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(#D4B896 0.5px, transparent 0.5px)", backgroundSize: "22px 22px" }} />
      <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-[#C9A87C]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-[480px] h-[480px] rounded-full bg-[#7C2D3D]/15 blur-3xl pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-5 sm:px-10 text-center">
        <div className="flex items-center justify-center gap-2 sm:gap-3 mb-7 sm:mb-9">
          <span className="w-10 sm:w-16 h-px bg-[#C9A87C]" />
          <Diamond className="w-3 h-3 sm:w-4 sm:h-4 text-[#D4B896]" />
          <span className="w-10 sm:w-16 h-px bg-[#C9A87C]" />
        </div>
        <h2 className="text-3xl sm:text-5xl lg:text-6xl leading-[1.1] mb-5 sm:mb-7"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
          <span className="text-white">{t.hookQuote}</span><br />
          <span className="italic text-[#D4B896]">{t.hookQuoteAccent}</span>
        </h2>
        <p className="text-sm sm:text-base lg:text-lg text-white/65 font-light max-w-2xl mx-auto leading-relaxed mb-12 sm:mb-16">
          {t.hookSubtitle}
        </p>

        {t.hookStats && (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-y-10 border-t border-white/10 pt-10 sm:pt-12">
            {t.hookStats.map((s, i) => (
              <div key={i} className="text-center" data-testid={`weddings-hook-stat-${i}`}>
                <div className="text-4xl sm:text-5xl lg:text-6xl text-[#D4B896] mb-2 sm:mb-3"
                     style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}>
                  {s.value}
                </div>
                <div className="text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] text-white/55 uppercase font-light">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
